<template>
    <div class="page">
        <!-- Banner -->
        <section class="hero" :style="heroStyle">
            <div class="hero-mask"></div>

            <div class="hero-inner">
                <h1 class="hero-title">服务与支持</h1>
                <p class="hero-sub">从需求沟通到交付服务，全流程陪伴每一位合作伙伴</p>

                <div class="hero-actions">
                    <a class="btn btn-primary" href="tel:13958349372">立即咨询</a>
                    <a class="btn btn-ghost" href="mailto:17371988805@163.com">邮件联系</a>
                </div>
            </div>
        </section>

        <!-- 合作流程 -->
        <section class="intro">
            <div class="container">
                <h3 class="sec-title">合作流程</h3>

                <div class="steps">
                    <div v-for="s in steps" :key="s.title" class="step">
                        <div class="step-num">{{ s.num }}</div>
                        <div class="step-title">{{ s.title }}</div>
                        <div class="step-desc">{{ s.desc }}</div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 服务优势 -->
        <section class="sec">
            <div class="container">
                <h3 class="sec-title">服务优势</h3>

                <div class="feature-grid">
                    <div v-for="f in features" :key="f.title" class="feature-card">
                        <div class="feature-ico" :class="f.color">{{ f.iconText }}</div>
                        <div class="feature-main">
                            <div class="feature-title">{{ f.title }}</div>
                            <div class="feature-desc">{{ f.desc }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 合作模式 -->
        <section class="sec">
            <div class="container">
                <h3 class="sec-title">合作模式</h3>

                <div class="adv-grid">
                    <div v-for="a in modes" :key="a.title" class="adv-card">
                        <div class="adv-ico">{{ a.iconText }}</div>
                        <div class="adv-title">{{ a.title }}</div>
                        <div class="adv-desc">{{ a.desc }}</div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
const heroStyle = {
    backgroundImage: "url(" + require("../static/2.webp") + ")",
};

const steps = [
    { num: "01", title: "需求沟通", desc: "电话或邮件沟通产品品类、规格、数量与交期等需求。" },
    { num: "02", title: "方案确认", desc: "确认工艺路线、打样要求与报价，签订合作意向。" },
    { num: "03", title: "打样生产", desc: "按需求打样确认，确认后进入稳定批量生产阶段。" },
    { num: "04", title: "质检交付", desc: "全流程品质把关，按约定交期安排发货与交付。" },
    { num: "05", title: "售后支持", desc: "交付后持续跟进，及时响应合作中的各项需求。" },
];

const features = [
    { iconText: "✦", color: "c1", title: "全品类制造", desc: "家电、照明、塑料、五金多品类协同制造，一站式满足配套需求。" },
    { iconText: "◎", color: "c2", title: "灵活定制", desc: "支持 OEM / ODM 与多元化定制生产，从打样到量产灵活切换。" },
    { iconText: "▦", color: "c3", title: "品质把控", desc: "从原料到成品建立规范质检流程，确保交付品质稳定可靠。" },
    { iconText: "▣", color: "c4", title: "稳定交期", desc: "成熟产线与生产管理，保障批量订单的交付节奏与一致性。" },
];

const modes = [
    {
        iconText: "➤",
        title: "OEM / ODM 定制",
        desc: "按客户设计或功能需求进行定制生产，覆盖多品类制造加工。",
    },
    {
        iconText: "✓",
        title: "批量代工",
        desc: "承接稳定批量的制造加工订单，交期与品质双重保障。",
    },
    {
        iconText: "◎",
        title: "进出口贸易",
        desc: "自营与代理进出口业务并行，助力客户对接国内外优质供应链。",
    },
    {
        iconText: "✉",
        title: "长期配套",
        desc: "面向长期合作客户建立稳定供应关系，提供协同化配套支持。",
    },
];
</script>

<style scoped>
.page {
    background: #fff;
}

/* ===== Banner ===== */
.hero {
    position: relative;
    min-height: 300px;
    background-size: cover;
    background-position: center;
    overflow: hidden;
}

.hero-mask {
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(6, 38, 78, 0.85), rgba(8, 58, 116, 0.5));
}

.hero-inner {
    position: relative;
    max-width: 1280px;
    margin: 0 auto;
    padding: 80px 24px 70px;
    color: #fff;
}

.hero-title {
    margin: 0;
    font-size: 38px;
    font-weight: 800;
    letter-spacing: 2px;
}

.hero-sub {
    margin: 14px 0 0;
    font-size: 17px;
    opacity: 0.92;
    line-height: 1.8;
}

.hero-actions {
    margin-top: 28px;
    display: flex;
    gap: 12px;
}

.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    padding: 0 26px;
    border-radius: 999px;
    border: 1px solid transparent;
    cursor: pointer;
    font-size: 14.5px;
    font-weight: 700;
    text-decoration: none;
    transition: transform 0.2s;
}

.btn:hover {
    transform: translateY(-2px);
}

.btn-primary {
    background: linear-gradient(135deg, #ffc53d, #f5a623);
    color: #17324d;
    box-shadow: 0 10px 24px rgba(245, 166, 35, 0.35);
}

.btn-ghost {
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.5);
}

/* ===== Common ===== */
.container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
}

.sec {
    padding: 64px 0;
}

.sec-title {
    text-align: center;
    font-size: 30px;
    font-weight: 800;
    color: #102a43;
    margin: 0 0 40px;
}

/* ===== 合作流程 ===== */
.intro {
    padding: 72px 0 40px;
}

.steps {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 18px;
}

.step {
    position: relative;
    text-align: center;
    padding: 28px 18px;
    border: 1px solid #eef1f5;
    border-radius: 14px;
    background: #fff;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.step:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 36px rgba(10, 79, 151, 0.1);
}

.step-num {
    font-size: 32px;
    font-weight: 800;
    color: #0a4f97;
    opacity: 0.85;
}

.step-title {
    margin-top: 10px;
    font-size: 16px;
    font-weight: 800;
    color: #102a43;
}

.step-desc {
    margin-top: 10px;
    font-size: 13px;
    line-height: 1.8;
    color: #7b8a9c;
}

/* ===== 服务优势：2x2 ===== */
.feature-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
}

.feature-card {
    background: #fff;
    border: 1px solid #eef1f5;
    border-radius: 14px;
    padding: 22px;
    display: flex;
    gap: 16px;
    align-items: flex-start;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.feature-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 30px rgba(10, 79, 151, 0.08);
}

.feature-ico {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 900;
    flex: 0 0 auto;
}

.feature-ico.c1 {
    background: #0a4f97;
}

.feature-ico.c2 {
    background: #77b255;
}

.feature-ico.c3 {
    background: #f2b36e;
}

.feature-ico.c4 {
    background: #46b6c7;
}

.feature-title {
    font-weight: 800;
    color: #102a43;
    font-size: 16px;
}

.feature-desc {
    margin-top: 8px;
    color: #7b8a9c;
    line-height: 1.8;
    font-size: 13px;
}

/* ===== 合作模式 ===== */
.adv-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
}

.adv-card {
    border: 1px solid #eef1f5;
    border-radius: 14px;
    padding: 24px 20px;
    background: #fff;
    text-align: center;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.adv-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 36px rgba(10, 79, 151, 0.1);
}

.adv-ico {
    width: 54px;
    height: 54px;
    border-radius: 14px;
    margin: 0 auto 14px;
    background: #e8f1fc;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0a4f97;
    font-weight: 900;
    font-size: 18px;
}

.adv-title {
    font-weight: 800;
    color: #102a43;
    font-size: 16px;
}

.adv-desc {
    margin-top: 10px;
    color: #7b8a9c;
    line-height: 1.8;
    font-size: 13px;
}

@media (max-width: 980px) {
    .steps {
        grid-template-columns: repeat(2, 1fr);
    }

    .adv-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .feature-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 520px) {
    .steps {
        grid-template-columns: 1fr;
    }

    .adv-grid {
        grid-template-columns: 1fr;
    }
}
</style>
